(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["jj-charity-donation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('jj-charity-donation')) {
    class JJCharityDonation extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.form = document.getElementById(this.dataset.formId);
        if (!this.form) return;
        this.controller = new AbortController();
        this.busy = false;
        this.initialLabel = this.querySelector('[data-button-label]').textContent;
        this.initiallyDisabled = this.querySelector('button[type="submit"]').disabled;
        this.money = new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency: this.dataset.currency });
        const settings = { signal: this.controller.signal };
        this.addEventListener('change', () => this.update(), settings);
        this.addEventListener('input', () => this.update(), settings);
        this.addEventListener('click', event => {
          const button = event.target.closest('.jj-charity__submit');
          if (!button || button.disabled) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          if (this.form.reportValidity()) this.submit();
        }, { ...settings, capture: true });
        const updateQuantity = event => {
          if (event.target.form === this.form && event.target.name === 'quantity') this.update();
        };
        document.addEventListener('input', updateQuantity, settings);
        document.addEventListener('change', updateQuantity, settings);
        document.addEventListener('submit', event => {
          if (event.target !== this.form) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          this.submit();
        }, { ...settings, capture: true });
        window.addEventListener('pageshow', event => {
          if (event.persisted && this.busy) this.release();
        }, settings);
        this.querySelector('[data-donation-options]')?.removeAttribute('hidden');
        this.update();
        this.setAttribute('data-ready', 'true');
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
      }

      selection() {
        const selected = this.querySelector('input[type="radio"]:checked');
        if (!selected || selected.value === '0') return { id: null, quantity: 0, total: 0, valid: true };
        if (selected.value !== 'custom') return { id: selected.value, quantity: 1, total: Number(selected.dataset.amount), valid: true };
        const raw = this.querySelector('[data-custom-amount]').value.trim();
        const amount = Number(raw);
        const valid = /^\d+$/.test(raw) && Number.isSafeInteger(amount) && amount >= Number(this.dataset.customMin) && amount <= Number(this.dataset.customMax);
        return { id: selected.dataset.variantId, quantity: amount, total: valid ? amount * 100 : 0, valid };
      }

      pinQuantity() {
        return Number(new FormData(this.form).get('quantity') || 1);
      }

      update() {
        const custom = this.querySelector('input[type="radio"]:checked')?.value === 'custom';
        const field = this.querySelector('[data-custom-field]');
        const input = this.querySelector('[data-custom-amount]');
        if (field) field.hidden = !custom;
        if (input) { input.disabled = !custom; input.removeAttribute('aria-invalid'); }
        const choice = this.selection();
        const extra = this.querySelector('[data-extra-total]');
        const total = this.querySelector('[data-purchase-total]');
        if (extra) extra.textContent = this.money.format(choice.total / 100);
        if (total) total.textContent = this.money.format((Number(this.dataset.pinPrice) * this.pinQuantity() + choice.total) / 100);
        if (!this.busy) this.querySelector('[data-error]').hidden = true;
      }

      showError(message, checkCart = false) {
        const error = this.querySelector('[data-error]');
        error.textContent = message;
        error.hidden = false;
        this.querySelector('[data-check-cart]').hidden = !checkCart;
        error.focus();
      }

      release() {
        this.busy = false;
        this.querySelector('button[type="submit"]').disabled = this.initiallyDisabled;
        this.querySelector('[data-button-label]').textContent = this.initialLabel;
        this.removeAttribute('aria-busy');
        const fieldset = this.querySelector('fieldset');
        if (fieldset) fieldset.disabled = false;
      }

      async submit() {
        if (this.busy) return;
        const choice = this.selection();
        if (!choice.valid) {
          this.showError(this.dataset.invalidMessage);
          const input = this.querySelector('[data-custom-amount]');
          input.setAttribute('aria-invalid', 'true');
          input.focus();
          return;
        }
        const quantity = this.pinQuantity();
        if (!Number.isSafeInteger(quantity) || quantity < 1) {
          this.showError(this.dataset.invalidQuantity);
          return;
        }
        this.busy = true;
        const button = this.querySelector('button[type="submit"]');
        const label = this.querySelector('[data-button-label]');
        button.disabled = true;
        label.textContent = this.dataset.busyLabel;
        this.setAttribute('aria-busy', 'true');
        const fieldset = this.querySelector('fieldset');
        if (fieldset) fieldset.disabled = true;
        const items = [{ id: this.dataset.pinId, quantity }];
        if (choice.total > 0) items.push({ id: choice.id, quantity: choice.quantity, properties: { _jj_charity_donation: 'true' } });
        try {
          const response = await fetch(this.dataset.addUrl, {
            method: 'POST',
            credentials: 'same-origin',
            signal: AbortSignal.timeout(15000),
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items })
          });
          if (!response.ok) throw new Error('Add request failed');
          const result = await response.json();
          if (!Array.isArray(result.items) || result.items.length !== items.length) throw new Error('Unconfirmed add');
          window.location.assign(this.dataset.cartUrl);
        } catch {
          this.showError(this.dataset.errorMessage, true);
          this.release();
        }
      }
    }
    customElements.define('jj-charity-donation', JJCharityDonation);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["jj-fitting-support"] && !Shopify.designMode) return;
  try {
    (() => {
  const config = document.getElementById('jj-fitting-config');
  if (!config) return;
  const labels = config.dataset;
  const normaliseInitials = value => String(value || '').trim().toUpperCase();
  const validInitials = value => /^[A-Z]{1,3}$/.test(normaliseInitials(value));
  const isFee = item => Number(item.product_id) === Number(labels.feeProduct) || Number(item.variant_id || item.id) === Number(labels.feeId);
  const needsInitials = item => isFee(item) || Object.hasOwn(item.properties || {}, 'embossing');
  const initialsIssues = cart => cart.items.filter(item => item.quantity > 0 && needsInitials(item) && !validInitials(item.properties?.embossing));
  const initialsDialog = document.getElementById('jj-required-initials-dialog');
  const initialsForm = initialsDialog.querySelector('form');
  const initialsFields = initialsDialog.querySelector('[data-jj-initials-fields]');
  const initialsError = initialsDialog.querySelector('[data-jj-initials-error]');
  let pendingInitials = [];
  let afterInitials = null;
  let initialsTrigger = null;
  let savingInitials = false;

  function validateFeeForm(form) {
    if (!form?.matches?.('form[action*="/cart/add"]')) return true;
    const variantInput = form.elements.namedItem('id');
    const productInput = form.elements.namedItem('product-id');
    const input = form.querySelector('[data-jj-required-initials]');
    if (!input && Number(variantInput?.value) !== Number(labels.feeId) && Number(productInput?.value) !== Number(labels.feeProduct)) return true;
    if (!input) {
      window.location.assign(labels.feeUrl);
      return false;
    }
    if (variantInput) {
      variantInput.disabled = false;
      variantInput.value = labels.feeId;
    }
    input.value = normaliseInitials(input.value);
    input.setCustomValidity(validInitials(input.value) ? '' : labels.requiredInvalid);
    if (!input.reportValidity()) { input.focus(); return false; }
    return true;
  }
  window.addEventListener('click', event => {
    const button = event.composedPath().find(node => node.matches?.('button[type="submit"], input[type="submit"]'));
    if (button && !validateFeeForm(button.form)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
  window.addEventListener('submit', event => {
    if (!validateFeeForm(event.target)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
  document.addEventListener('input', event => {
    if (!event.target.matches?.('[data-jj-required-initials], [data-jj-initials-edit]')) return;
    event.target.value = event.target.value.toUpperCase();
    event.target.setCustomValidity('');
    initialsError.hidden = true;
  });

  function showInitialsEditor(cart, trigger, action) {
    pendingInitials = initialsIssues(cart);
    afterInitials = () => check(trigger, action);
    initialsTrigger = trigger;
    initialsError.hidden = true;
    initialsFields.replaceChildren();
    const personalisedItems = cart.items.filter(item => !isFee(item) && validInitials(item.properties?.embossing));
    pendingInitials.forEach((item, index) => {
      const group = document.createElement('div');
      group.className = 'jj-initials-field';
      const label = document.createElement('label');
      const input = document.createElement('input');
      const hint = document.createElement('p');
      input.id = 'jj-cart-initials-' + index;
      input.className = 'input';
      input.type = 'text';
      input.required = true;
      input.minLength = 1;
      input.maxLength = 3;
      input.pattern = '[A-Za-z]{1,3}';
      input.autocomplete = 'off';
      input.autocapitalize = 'characters';
      input.spellcheck = false;
      input.setAttribute('data-jj-initials-edit', String(index));
      const matches = personalisedItems.filter(binder => String(binder.variant_id) === String(item.properties?._jj_personalisation_for));
      const prefill = matches.length === 1 ? matches[0] : personalisedItems.length === 1 ? personalisedItems[0] : null;
      input.value = normaliseInitials(item.properties?.embossing || (isFee(item) ? prefill?.properties?.embossing : ''));
      label.htmlFor = input.id;
      label.textContent = labels.requiredLabel + ' — ' + (item.product_title || item.title) + (item.quantity > 1 ? ' × ' + item.quantity : '');
      hint.id = input.id + '-hint';
      hint.textContent = labels.requiredHint;
      input.setAttribute('aria-describedby', hint.id);
      group.append(label, input, hint);
      initialsFields.append(group);
    });
    initialsDialog.showModal();
    initialsFields.querySelector('input')?.focus();
  }
  initialsDialog.querySelector('[data-jj-initials-close]').addEventListener('click', () => {
    if (!savingInitials) initialsDialog.close();
  });
  initialsDialog.addEventListener('cancel', event => { if (savingInitials) event.preventDefault(); });
  initialsDialog.addEventListener('close', () => { afterInitials = null; initialsTrigger?.focus(); });
  initialsForm.addEventListener('submit', async event => {
    event.preventDefault();
    if (savingInitials) return;
    const fields = Array.from(initialsFields.querySelectorAll('input'));
    fields.forEach(input => {
      input.value = normaliseInitials(input.value);
      input.setCustomValidity(validInitials(input.value) ? '' : labels.requiredInvalid);
    });
    if (!initialsForm.reportValidity()) return;
    savingInitials = true;
    initialsError.hidden = true;
    initialsForm.setAttribute('aria-busy', 'true');
    const buttons = Array.from(initialsForm.querySelectorAll('button'));
    buttons.forEach(button => { button.disabled = true; });
    try {
      for (let index = 0; index < pendingInitials.length; index++) {
        const item = pendingInitials[index];
        const response = await fetch(labels.cartUrl + '/change.js', {
          method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: item.key, quantity: item.quantity, properties: { ...item.properties, embossing: fields[index].value } }),
          signal: AbortSignal.timeout(15000)
        });
        if (!response.ok) throw new Error(labels.requiredSaveError);
      }
      const next = afterInitials;
      initialsDialog.close();
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      next?.();
    } catch {
      initialsError.textContent = labels.requiredSaveError;
      initialsError.hidden = false;
    } finally {
      savingInitials = false;
      initialsForm.removeAttribute('aria-busy');
      buttons.forEach(button => { button.disabled = false; });
    }
  });

  const states = new Map();
  const fittingOf = value => /\bring(?:[-\s\u2010-\u2015]*bound)?\b/i.test(value || '') ? 'ring' : /\bdisc(?:[-\s\u2010-\u2015]*bound)?\b/i.test(value || '') ? 'disc' : null;
  const itemFitting = item => fittingOf(item.variant_title) || fittingOf(item.product_title || item.title) || fittingOf(item.product_type);
  const setText = (element, text) => { if (element && element.textContent !== text) element.textContent = text; };
  const groupFor = form => Array.from(document.querySelectorAll('[data-jj-fitting]')).find(group => document.getElementById(group.dataset.form) === form);
  const stateFor = (form, group) => {
    const key = `${form.id}:${group.dataset.product}`;
    let state = states.get(key);
    if (!state) {
      state = { product: group.dataset.product, value: null, name: '', pending: false, ready: false };
      states.set(key, state);
    }
    return state;
  };
  function refreshGroup(group) {
    const form = document.getElementById(group.dataset.form);
    if (!form) return;
    const state = stateFor(form, group);
    const variantData = group.closest('variant-picker')?.querySelector('script[data-variant]');
    let variant = null;
    try { variant = JSON.parse(variantData?.textContent || 'null'); } catch {}
    const variantInput = form.querySelector('input[name="id"]');
    if (state.variant && String(state.variant.id) === variantInput?.value) variant = state.variant;
    const picker = group.closest('variant-picker');
    const otherOptionsMatch = Array.from(picker?.querySelectorAll('input[data-option-position]:checked') || []).every(input => group.contains(input) || input.defaultChecked);
    const matched = Boolean(state.value && otherOptionsMatch && variant?.options?.[Number(group.dataset.position) - 1] === state.name && String(variant.id) === variantInput?.value);
    state.ready = Boolean(matched && variant.available && !variantInput.disabled);
    if (matched) state.pending = false;
    group.querySelectorAll('input[type="radio"]').forEach(input => { input.checked = input.value === state.value; });
    const message = group.querySelector('[data-jj-fitting-message]');
    setText(message, state.pending ? labels.loading : state.ready ? labels.selected.replace('[fitting]', state.name) : labels.choose);
    const property = form.querySelector('[data-jj-fitting-property]');
    if (property) { property.disabled = !state.ready; property.value = state.ready ? state.name : ''; }
    const button = form.querySelector('buy-buttons button[type="submit"]');
    if (button && !button.disabled && button.getAttribute('aria-busy') !== 'true') {
      setText(button, state.pending ? labels.loading : state.ready ? labels[fittingOf(state.name)] : labels.choose);
    }
  }
  const refresh = () => document.querySelectorAll('[data-jj-fitting]').forEach(refreshGroup);
  document.addEventListener('change', event => {
    const input = event.target;
    if (!input.matches?.('input[data-option-position]')) return;
    const form = input.form;
    const group = form && groupFor(form);
    if (!group) return;
    const state = stateFor(form, group);
    if (input.matches('[data-fitting-name]')) { state.value = input.value; state.name = input.dataset.fittingName; }
    state.ready = false;
    state.pending = Boolean(state.value);
    refreshGroup(group);
  }, true);
  document.addEventListener('product:rerender', () => queueMicrotask(refresh), true);
  document.addEventListener('variant:change', event => {
    const form = document.getElementById(event.target.getAttribute('id')) || event.target;
    const group = groupFor(form);
    if (!group) return;
    const state = stateFor(form, group);
    const variant = event.detail.variant;
    state.variant = variant;
    const matched = variant?.options?.[Number(group.dataset.position) - 1] === state.name;
    state.pending = false;
    state.ready = Boolean(state.value && matched && variant.available);
    refreshGroup(group);
  });
  document.addEventListener('submit', event => {
    const group = groupFor(event.target);
    if (!group) return;
    refreshGroup(group);
    const state = stateFor(event.target, group);
    if (!state.ready) {
      event.preventDefault();
      event.stopImmediatePropagation();
      refreshGroup(group);
      group.querySelector('input:checked, input')?.focus();
    }
  }, true);
  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    queueMicrotask(() => { queued = false; refresh(); });
  }).observe(document.body, { childList: true, subtree: true });
  refresh();

  let drawerAttempts = 0;
  function protectDrawerShortcuts() {
    const root = document.getElementById('upCart')?.shadowRoot;
    if (!root) {
      if (++drawerAttempts < 120) setTimeout(protectDrawerShortcuts, 500);
      return;
    }
    const style = document.createElement('style');
    style.textContent = ':host([data-jj-fitting-cart]) .upcart-public-express-payments__container { display: none !important; }';
    root.append(style);
    const update = () => {
      const hasFitting = Array.from(root.querySelectorAll('.upcart-internal-cart-items__key-value-pair, a[href*="/products/"]')).some(node => fittingOf(node.textContent));
      const hasInitials = Array.from(root.querySelectorAll('a[href], .upcart-internal-cart-items__key-value-pair')).some(node => node.getAttribute('href')?.includes('/products/personalised-embossing') || /embossing/i.test(node.textContent));
      root.host.toggleAttribute('data-jj-fitting-cart', hasFitting || hasInitials);
    };
    new MutationObserver(update).observe(root, { childList: true, subtree: true, characterData: true });
    update();
  }
  protectDrawerShortcuts();

  const dialog = document.getElementById('jj-fitting-warning');
  const bypass = new WeakSet();
  let busy = false;
  let resume = null;
  let previousFocus = null;
  let approvedSignature = null;
  let repairingFees = false;

  function missingEmbossing(cart) {
    const fees = cart.items.filter(item => item.quantity > 0 && isFee(item)).map(item => ({ item, remaining: item.quantity }));
    const personalised = cart.items.filter(item => item.quantity > 0 && !isFee(item) && validInitials(item.properties?.embossing));
    const missing = personalised.map(item => ({ item, quantity: item.quantity }));
    for (const linked of [true, false]) {
      for (const entry of missing) {
        for (const fee of fees) {
          const parent = fee.item.properties?._jj_personalisation_for;
          if (Boolean(parent) !== linked || (parent && String(parent) !== String(entry.item.variant_id || entry.item.id))) continue;
          if (normaliseInitials(fee.item.properties?.embossing) !== normaliseInitials(entry.item.properties.embossing)) continue;
          const covered = Math.min(entry.quantity, fee.remaining);
          entry.quantity -= covered;
          fee.remaining -= covered;
        }
      }
    }
    return missing.filter(entry => entry.quantity > 0);
  }

  async function addMissingEmbossing(trigger, action) {
    if (repairingFees) return;
    repairingFees = true;
    try {
      const response = await fetch(labels.cartUrl + '.js', { credentials: 'same-origin', cache: 'no-store', signal: AbortSignal.timeout(8000) });
      if (!response.ok) throw new Error('Cart unavailable');
      const cart = await response.json();
      const missing = missingEmbossing(cart);
      if (initialsIssues(cart).length || !missing.length) {
        await check(trigger, action);
        return;
      }
      const productResponse = await fetch(labels.feeUrl + '.js', { credentials: 'same-origin', cache: 'no-store', signal: AbortSignal.timeout(8000) });
      if (!productResponse.ok) throw new Error('Embossing unavailable');
      const product = await productResponse.json();
      const variant = product.variants.find(item => Number(item.id) === Number(labels.feeId));
      if (!variant?.available) throw new Error('Embossing unavailable');
      const items = missing.map(({ item, quantity }) => ({
        id: Number(labels.feeId), quantity,
        properties: {
          embossing: normaliseInitials(item.properties.embossing),
          _jj_personalisation_for: String(item.variant_id || item.id),
          ...(item.properties['Part of'] ? { 'Part of': item.properties['Part of'] } : {})
        }
      }));
      const added = await fetch(labels.cartUrl + '/add.js', {
        method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items }), signal: AbortSignal.timeout(15000)
      });
      if (!added.ok) throw new Error('Embossing could not be added');
      window.location.assign(labels.cartUrl);
    } catch {
      showWarning(labels.requiredCheckError, [], () => check(trigger, action), trigger, true);
      setText(dialog.querySelector('[data-jj-continue]'), labels.requiredRetry);
    } finally {
      repairingFees = false;
    }
  }
  function compatibility(items) {
    const products = items.filter(item => item.quantity > 0).map(item => ({ item, fitting: itemFitting(item) }));
    const plannerTypes = ['ring binder', 'ring binder cover', 'disc cover', 'disc binder', 'disc planner', 'disc system', 'acrylic cover'];
    const isPlanner = ({ item, fitting }) => fitting && plannerTypes.includes((item.product_type || '').trim().toLowerCase());
    const systems = new Set(products.filter(isPlanner).map(product => product.fitting));
    const components = products.filter(product => product.fitting && !isPlanner(product));
    const mixed = new Set(components.map(product => product.fitting)).size > 1;
    const mismatches = components.filter(product => systems.size === 1 && !systems.has(product.fitting));
    const issues = mismatches.length ? mismatches : mixed && systems.size < 2 ? components : [];
    return { items: issues.map(product => product.item), mismatch: mismatches.length > 0 };
  }
  function showWarning(message, items, action, trigger, initials = false) {
    resume = action;
    previousFocus = trigger;
    setText(dialog.querySelector('#jj-fitting-warning-title'), initials ? labels.initialsTitle : labels.warningTitle);
    setText(dialog.querySelector('[data-jj-continue]'), initials ? labels.initialsContinue : labels.fittingContinue);
    dialog.querySelector('[data-jj-fitting-advice]').hidden = initials;
    setText(dialog.querySelector('#jj-fitting-warning-message'), message);
    const list = dialog.querySelector('[data-jj-warning-items]');
    list.replaceChildren(...items.map(item => {
      const li = document.createElement('li');
      li.textContent = [item.product_title || item.title, item.variant_title === 'Default Title' ? '' : item.variant_title].filter(Boolean).join(' — ');
      return li;
    }));
    dialog.showModal();
  }
  async function check(trigger, action) {
    if (busy) return;
    busy = true;
    trigger.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(labels.cartUrl + '.js', { credentials: 'same-origin', cache: 'no-store', signal: AbortSignal.timeout(8000) });
      if (!response.ok) throw new Error('Cart unavailable');
      const cart = await response.json();
      if (initialsIssues(cart).length) {
        showInitialsEditor(cart, trigger, action);
        return;
      }
      const signature = JSON.stringify(cart.items.map(item => [item.key, item.quantity, item.final_line_price, item.properties]));
      const afterFittings = () => {
        const missing = missingEmbossing(cart);
        if (!missing.length) return action();
        showWarning(labels.initialsMessage.replace('[price]', labels.feePrice), missing.map(({ item }) => item), () => addMissingEmbossing(trigger, action), trigger, true);
      };
      const result = compatibility(cart.items);
      if (result.items.length && signature !== approvedSignature) showWarning(result.mismatch ? labels.mismatch : labels.mixed, result.items, () => { approvedSignature = signature; afterFittings(); }, trigger);
      else afterFittings();
    } catch {
      showWarning(labels.requiredCheckError, [], () => check(trigger, action), trigger, true);
      setText(dialog.querySelector('[data-jj-continue]'), labels.requiredRetry);
    } finally {
      busy = false;
      trigger.removeAttribute('aria-busy');
    }
  }
  dialog.querySelector('[data-jj-review]').addEventListener('click', () => {
    resume = null;
    dialog.close();
    window.location.assign(labels.cartUrl);
  });
  dialog.querySelector('[data-jj-continue]').addEventListener('click', () => {
    const action = resume;
    resume = null;
    dialog.close();
    action?.();
  });
  dialog.addEventListener('close', () => { previousFocus?.focus(); });
  window.addEventListener('click', event => {
    const trigger = event.composedPath().find(node => node.matches?.('button[name="checkout"], input[name="checkout"], a[href*="/checkout"], a[href*="/cart/c/"], .upcart-checkout-button'));
    if (!trigger || bypass.has(trigger)) return;
    if (trigger.matches('a')) {
      const url = new URL(trigger.href, location.href);
      if (url.origin !== location.origin || !trigger.matches('.upcart-checkout-button') && !/\/(?:checkouts?(?:\/|$)|cart\/c\/)/.test(url.pathname)) return;
    }
    event.preventDefault();
    event.stopImmediatePropagation();
    check(trigger, () => {
      bypass.add(trigger);
      if (trigger.form) bypass.add(trigger.form);
      trigger.click();
      bypass.delete(trigger);
      if (trigger.form) setTimeout(() => bypass.delete(trigger.form), 0);
    });
  }, true);
  window.addEventListener('submit', event => {
    const form = event.target;
    if (!form.matches?.('form[action*="/cart"]') || form.action.includes('/cart/add') || bypass.has(form)) return;
    if (event.submitter && event.submitter.name !== 'checkout') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const submitter = event.submitter;
    check(submitter || form, () => {
      bypass.add(form);
      form.requestSubmit(submitter || undefined);
      setTimeout(() => bypass.delete(form), 0);
    });
  }, true);
})();
  } catch(e) { console.error(e); }
})();

})();
